// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1ZS2e","container_1":"container_1___GUSat","container_2":"container_2___3ymFK"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/banner/styles.module.scss
// module id = 863
// module chunks = 0